import { atom } from "recoil";

export type SelectedAutomaticThoughtState =
  | { id?: number; isForValue?: boolean }
  | undefined;

export const selectedAutomaticThoughtIdAtom = atom<SelectedAutomaticThoughtState>({
  key: "selectedAutomaticThoughtId",
  default: undefined,
});